// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__3rfEI","square":"style_square__Dj4Gj","tab":"style_tab__oJuiF","circle":"style_circle__g8LwG","icon":"style_icon__uKyDy","active":"style_active__Ht0+9"};